export const PASSWORD_CHANGE_CLEAR_ERROR = 'PASSWORD_CHANGE/CLEAR_ERROR';
export const PASSWORD_CHANGE_START = 'PASSWORD_CHANGE/START';
export const PASSWORD_CHANGE_COMPLETE = 'PASSWORD_CHANGE/COMPLETE';
export const PASSWORD_CHANGE_ERROR = 'PASSWORD_CHANGE/ERROR';
export const PASSWORD_CHANGE_VALIDATION_ERROR = 'PASSWORD_CHANGE/VALIDATION_ERROR';
export const PASSWORD_CHANGE_CLEAR_VALIDATION_ERRORS = 'PASSWORD_CHANGE/CLEAR_VALIDATION_ERRORS';